// Route helpers for frontend
export const dashboardPath = () => "/tablero"
export const feedPath = () => "/feed"
export const discoverPath = () => "/descubrir"
// My Neighborhood
export const myNeighborhoodPath = () => "/mi-barrio"

// Events
export const eventsPath = () => "/eventos"
export const eventPath = (id: number | string) => `/eventos/${id}`
export const eventsNewPath = () => "/eventos/new"
export const eventsEditPath = (id: number | string) => `/eventos/${id}/edit`

export const eventAttendeesPath = (eventId: number | string) =>
  `/eventos/${eventId}/asistentes`
export const eventAttendeePath = (
  eventId: number | string,
  attendeeId: number | string,
) => `/eventos/${eventId}/asistentes/${attendeeId}`

// Forum
export const forumPath = () => "/foro"
export const forumPostPath = (id: number | string) => `/foro/posts/${id}`
export const forumPostsNewPath = () => "/foro/posts/new"
export const forumPostsPath = () => "/foro/posts"
export const forumPostsEditPath = (id: number | string) =>
  `/foro/posts/${id}/edit`

// Announcements
export const announcementsPath = () => "/anuncios"
export const announcementPath = (id: number | string) => `/anuncios/${id}`

// Raffles
export const rafflesPath = () => "/sorteos"
export const rafflePath = (id: number | string) => `/sorteos/${id}`
export const raffleParticipantPath = (
  raffleId: number | string,
  participantId: number | string,
) => `/sorteos/${raffleId}/participantes/${participantId}`
export const raffleNewPath = () => "/sorteos/new"
export const raffleEditPath = (id: number | string) => `/sorteos/${id}/edit`

// Marketplace
export const marketplacePath = () => "/mercado"
export const marketplaceProductsPath = () => "/mercado/productos"

// Interviews
export const interviewsPath = () => "/entrevistas"
export const interviewPath = (id: number | string) => `/entrevistas/${id}`
export const interviewsNewPath = () => "/entrevistas/new"
export const interviewsEditPath = (id: number | string) =>
  `/entrevistas/${id}/edit`

// Jobs (Curros)
export const jobsPath = () => "/curros"
export const jobPath = (id: number | string) => `/curros/${id}`
export const jobsNewPath = () => "/curros/new"
export const jobsEditPath = (id: number | string) => `/curros/${id}/edit`

// Products
export const productPath = (id: number | string) => `/productos/${id}`
export const productsNewPath = () => "/productos/new"
export const productsCreatePath = () => "/productos"
export const productsEditPath = (id: number | string) => `/productos/${id}/edit`

// Stories
export const storiesPath = () => "/historias"
export const storiesNewPath = () => "/historias/new"
export const storyViewPath = (id: number | string) => `/historias/${id}/view`
export const storyViewersPath = (id: number | string) =>
  `/historias/${id}/viewers`

// Businesses
export const businessPath = (id: number | string) => `/negocios/${id}`
export const businessesNewPath = () => "/negocios/new"
export const businessesCreatePath = () => "/negocios"
export const businessesEditPath = (id: number | string) =>
  `/negocios/${id}/edit`

// Auth
export const signInPath = () => "/iniciar-sesion"
export const signUpPath = () => "/registro"

// Identity/Password Reset
export const identityPasswordResetPath = () => "/identity/password_reset"
export const newIdentityPasswordResetPath = () => "/identity/password_reset/new"
export const identityEmailVerificationPath = () =>
  "/identity/email_verification"

// Sessions
export const sessionPath = (id: number | string) => `/sessions/${id}`

// Users
export const usersPath = () => "/users"
export const userPath = (id: number | string) => `/perfil/${id}`

// Settings
export const settingsAppearancePath = () => "/settings/appearance"
export const settingsEmailPath = () => "/settings/email"
export const settingsPasswordPath = () => "/settings/password"
export const settingsPrivacyPath = () => "/settings/privacy"
export const settingsProfilePath = () => "/settings/profile"
export const settingsNotificationsPath = () => "/settings/notifications"
export const settingsSessionsPath = () => "/settings/sessions"
export const settingsLocationPath = () => "/settings/location"
export const unhideSettingsPrivacyPath = () => "/settings/privacy/unhide"
export const unblockSettingsPrivacyPath = () => "/settings/privacy/unblock"
export const favoritesPath = () => "/favoritos"
export const notificationsPath = () => "/notificaciones"

// Root
export const rootPath = () => "/"

// Cart
export const cartPath = () => "/carrito"
export const cartItemsPath = () => "/carrito/articulos"

// Orders (Spanish URLs)
export const ordersPath = () => "/pedidos"
export const orderPath = (id: number | string) => `/pedidos/${id}`

// Business Orders Management
export const businessOrdersPath = () => "/mi-negocio/pedidos"
export const businessOrderPath = (id: number | string) =>
  `/mi-negocio/pedidos/${id}`

// Chat
export const chatGroupsPath = () => "/chat"
export const chatMessagesPath = () => "/chat/mensajes"

// Content Moderation
export const reportsPath = () => "/reportes"
export const contentHidesPath = () => "/ocultaciones"
export const contentHidePath = (id: number | string) => `/ocultaciones/${id}`
export const userBlocksPath = () => "/bloqueos"
export const userBlockPath = (id: number | string) => `/bloqueos/${id}`

// Admin (Spanish paths)
export const adminUsersPath = () => "/admin/usuarios"
export const adminEventsPath = () => "/admin/eventos"
export const adminRafflesPath = () => "/admin/sorteos"
export const adminReportsPath = () => "/admin/reports"
export const adminReportPath = (id: number | string) => `/admin/reports/${id}`
export const resolveAdminReportPath = (id: number | string) =>
  `/admin/reports/${id}/resolve`
export const dismissAdminReportPath = (id: number | string) =>
  `/admin/reports/${id}/dismiss`
export const reviewAdminReportPath = (id: number | string) =>
  `/admin/reports/${id}/review`
export const adminBusinessesPath = () => "/admin/negocios"
export const adminInterviewsPath = () => "/admin/entrevistas"
